import client from "./client";

export default {
    async getTicketCategories(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/ticket-categories', filters)));
    },

    async createTicketCategories(data) {
        return client.parseResponse(await client.post('/ticket-categories', data))
    },

    async getTicketCategory(id) {
        return client.parseResponse(await client.get('/ticket-categories/' + id));
    },

    async editTicketCategory(data) {
        return client.parseResponse(await client.put('/ticket-categories/' + data.id, data))
    },

    async deleteTicketCategory(data) {
        return client.parseResponse(await client.delete('/ticket-categories/' + data.id, data))
    }
}
